import { GuideChecklistItem, GuideFlowMeta } from './types';

export const GUIDE_STORAGE_KEY = 'tf_full_guide_progress';

// Adding a new flow: append here, add its checklist items below, and add a
// matching <Route> + screen component under replica/.
export const GUIDE_FLOWS: GuideFlowMeta[] = [
  {
    id: 'employee',
    title: 'Add an employee',
    description: 'Go to Employees, create one, and send them the app link.',
  },
  {
    id: 'project-task',
    title: 'Create & assign a task',
    description: 'Create a project, add a task, and assign it to a teammate.',
  },
  {
    id: 'configuration',
    title: 'Configure your settings',
    description: 'A quick look at your configuration options.',
  },
];

// stepIndex must match the step's position in that flow's own `steps` array
// (see replica/EmployeeFlow.tsx, ProjectTaskFlow.tsx, ConfigurationFlow.tsx).
export const GUIDE_CHECKLIST: GuideChecklistItem[] = [
  { id: 'emp-visit', flow: 'employee', label: 'Visit the Employees page', stepIndex: 0 },
  { id: 'emp-import', flow: 'employee', label: 'Import employees from Excel', stepIndex: 1 },
  { id: 'emp-link', flow: 'employee', label: 'Generate a self-registration link', stepIndex: 3 },
  { id: 'emp-create', flow: 'employee', label: 'Add a new employee', stepIndex: 5 },
  { id: 'emp-invite', flow: 'employee', label: 'Send them the app link', stepIndex: 7 },
  { id: 'proj-create', flow: 'project-task', label: 'Create a project', stepIndex: 0 },
  { id: 'task-create', flow: 'project-task', label: 'Create a task', stepIndex: 2 },
  { id: 'task-assign', flow: 'project-task', label: 'Assign it to an employee', stepIndex: 4 },
  { id: 'config-explore', flow: 'configuration', label: 'Explore configuration settings', stepIndex: 0 },
];
